import { Link } from 'react-router-dom';
import VLibras from 'react-vlibras';
import Header from './headerClinica'; 
import AboutClinica from './AboutClinica';

const About = () => {
    return (
      <div>
        <Header />
        <VLibras />
        <AboutClinica />
      </div>
    );
  };
  
  export default About;
  